<template>
  <v-textarea v-model="data" required @input="$v.data.$touch()" light solo auto-grow rows="1" class="custom-textarea"
                :error-messages="dataErrors" :readonly="!canEdit"></v-textarea>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { requiredIf } from 'vuelidate/lib/validators'

export default {
  props: {
    requerimiento: Object,
    canEdit: Boolean
  },

  mixins: [validationMixin],

  validations () {
    return {
      data: { required: requiredIf(() => { return !this.requerimiento.optional }) }
    }
  },

  data () {
    return {
      data: ''
    }
  },

  computed: {
    dataErrors () {
      const errors = []
      if (!this.$v.data.$dirty) return errors
      !this.isValidEmail() && errors.push('Email inválido.')
      !this.$v.data.required && errors.push('Campo requerido.')
      return errors
    }
  },

  methods: {
    isValid () {
      if (!this.canEdit) return true
      this.$v.$touch()
      return !this.$v.$invalid && this.isValidEmail(this.data)
    },
    isValidEmail () {
      if (!this.data) return true
      let rule = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return rule.test(this.data.toLowerCase())
    },
    isModified () {
      return this.requerimiento.data !== this.data
    },
    getData () {
      return this.data
    }
  },

  created () {
    this.data = this.requerimiento.data
  }
}
</script>
